window.colors = {
    "colors": []
};

var addColor = document.getElementById("add-color");

var id = 0;

addColor.addEventListener("click", function(){

    var colorsContainer = document.getElementById("colors-container");

    var newColor = document.createElement("div");
    newColor.classList.add("color-settings","settings-sub-block-content-line");
    newColor.setAttribute("data-id", id);

    var newColorInfo = document.createElement('div');
    newColorInfo.classList.add("color-info");

    // Color Name
    var newColorName = document.createElement("input");
    newColorName.setAttribute("type", "text");
    newColorName.setAttribute("value", "color"+id);
    newColorName.setAttribute("placeholder", "Add color name");
    newColorName.classList.add("color-name");
    newColorName.setAttribute("data-id", id);

    newColorName.addEventListener("change", function(event){
        var element = this;
        var idElement = element.getAttribute("data-id");

        var nameExists = false;

        window.colors.colors.forEach(function(obj, i){
            if (obj.settings.name == event.target.value) {
                nameExists = true;
            }
        });
        
        if (!nameExists) {
            window.colors.colors.forEach(function(obj, i){
                if (idElement == obj.id) {
                    obj.settings.name = event.target.value;
                }
            });
        } else {
            alert("You can not repeat the name of the color.");
            newColorName.value = "";
        }

        window.updateColors();
    });

    // Color selection
    var newColorColor = document.createElement("input");
    newColorColor.setAttribute("type", "color");
    newColorColor.classList.add("color-color");
    newColorColor.setAttribute("data-id", id);

    newColorColor.addEventListener("change", function(event){
        var element = this;
        var idElement = element.getAttribute("data-id");

        var textInput = element.nextSibling;
        textInput.value = event.target.value;

        window.colors.colors.forEach(function(obj, i){

            if (idElement == obj.id) {
                obj.settings.color = event.target.value;
            }
        })
        window.updateColors();
    });

    // Color selection text
    var newColorColorText = document.createElement('input');
    newColorColorText.setAttribute("type", "text");
    newColorColorText.setAttribute("data-id", id);
    newColorColorText.setAttribute("value", "#000000");
    newColorColorText.setAttribute("placeholder", "#000000");
    newColorColorText.classList.add("color-color-text");
    newColorColorText.addEventListener('change', function(event){
        var element = this;
        var idElement = element.getAttribute("data-id");

        var colorInput = element.previousSibling;
        colorInput.value = event.target.value;

        window.colors.colors.forEach(function(obj, i){
            if (idElement == obj.id) {
                obj.settings.color = event.target.value;
            }
        })

        window.updateColors();
    })

    // Color Remove
    var newColorRemove = document.createElement("div");
    newColorRemove.classList.add("remove-color");
    newColorRemove.addEventListener('click', function(){
        var element = this;

        var idElement = element.parentNode.getAttribute("data-id");

        window.colors.colors.forEach(function(obj, i){

            if (idElement == obj.id) {
                window.colors.colors.splice(i, 1);
            }
        })
        element.parentNode.remove();

        window.updateColors();
    })
    var newRemoveColorLogo = document.createElement("div");
    newRemoveColorLogo.classList.add("remove-color-logo");


    newColorInfo.append(newColorName);
    newColorInfo.append(newColorColor);
    newColorInfo.append(newColorColorText);
    newColor.append(newColorInfo);
    newColor.append(newColorRemove);
    newColorRemove.append(newRemoveColorLogo);

    colorsContainer.append(newColor);

    var newColorJSON = {
        "id": id,
        "settings": {
            "name": "color"+id,
            "color": "#000000",
            "opacity": "100%"
        }
    };

    window.colors['colors'].push(newColorJSON);

    id++;

    window.updateColors();
});

window.updateColors = function() {
//function updateColors() {
    // Fonts
    window.updateColorFonts();

    // Background
    window.updateColorBackground();

    // Header
    window.updateColorHeader();             // Fill
    window.updateHeaderBorderColor();       // Border
    window.updateHeaderShadowColor();       // Shadow

    // Menu
    window.updateColorMenuBackground();

    // Chat Bubble - Bot
    window.updateBotBubbleColor();          // Fill
    window.updateBotBubbleTextColor();      // Text
    window.updateBotBubbleBorderColor();    // Border
    window.updateBotBubbleShadowColor();    // Shadow

    // Chat Bubble - User
    window.updateUserBubbleColor();         // Fill
    window.updateUserBubbleTextColor();     // Text
    window.updateUserBubbleBorderColor();   // Border
    window.updateUserBubbleShadowColor();   // Shadow

    // Quick Reply
    window.updateQuickReplyColor();             // Fill
    window.updateQuickReplyTextColor();         // Text
    window.updateQuickReplyBorderColor();       // Border
    window.updateQuickReplyShadowColor();       // Shadow
    window.updateQuickReplyHoverColor();        // Fill Hover
    window.updateQuickReplyHoverTextColor();    // Text Hover
    window.updateQuickReplyHoverBorderColor();  // Border Hover
    window.updateQuickReplyShadowColorHover();  // Shadow Hover

    // Link Button
    window.updateLinkButtonColor();             // Fill
    window.updateLinkButtonTextColor();         // Text
    window.updateLinkButtonBorderColor();       // Border
    window.updateLinkButtonShadowColor();       // Shadow
    window.updateLinkButtonHoverColor();        // Fill Hover
    window.updateLinkButtonHoverTextColor();    // Text Hover
    window.updateLinkButtonHoverBorderColor();  // Border Hover
    window.updateLinkButtonShadowColorHover();  // Shadow Hover

    // Wechat Input
    window.updateChatInputColor();          // Fill
    window.updateChatInputColorText();      // Text Color
    window.updateChatInputBorderColor();    // Border
    window.updateChatInputShadowColor();    // Shadow

    // Gallery
    window.updateColorBackgroundGallery();  // Fill

}

window.updateColors();